import React from "react";
import ConfirmationModalNew from "../../common/ConfirmationModalNew";
import { formatToYYYY_MMM_DD } from "../../../helpers/functions";

const DuplicatePatientDialog = ({
  open,
  onClose,
  onCancel,
  onGoToPatientChart,
  patientName,
  dateOfBirth,
}) => {

  const formattedName = patientName || "";
  const formattedDob = dateOfBirth ? formatToYYYY_MMM_DD(dateOfBirth) : "";

  return (
    <ConfirmationModalNew
      open={open}
      handleClose={onClose}
      onCross={onClose}
      title="Same Name Alert"
      titleClassName="text-teal-300  font-semibold text-2xl"
      headClassName="px-8 pt-8 pb-4 border-b border-gray-200"
      content={() => (
        <div className="flex flex-col gap-4">
          <p className="text-gray-800 text-base font-normal">
              This patient - <span className="text-teal-300 font-[500]">{formattedName}</span>
              ({` Date of Birth: ${formattedDob || 'N/A'}`}), shares the personal information with another patient in your pharmacy.
              <br/>
              <br/> Ensure you are accessing the correct Patient Chart.
          </p>
        </div>
      )}
      className="flex flex-col gap-8 max-w-lg w-[600px] bg-gray-20"
      hideHR={true}
      hideActions={true}
      verticalButtons={true}
      extraButtonComponent={() => (
        <div className="w-full">
          <div className="grid grid-cols-1">
            <button
              className="w-full py-3 rounded-md bg-REELTeal text-white font-semibold"
              onClick={() => onClose()}
            >
              Okay
            </button>
          </div>
        </div>
      )}
      options={[]}
      requireInput={false}
    />
  );
};

export default DuplicatePatientDialog;
